/*
  Valerique — size-quiz in de Kiwi Size Chart-modal (PDP).
  Kiwi bouwt de modal pas bij het openen; een MutationObserver op
  document.body injecteert de quiz tussen .ks-table-wrapper en
  .ks-table-footer (zonder voetnoot: direct onder de tabel).

  Advies-logica leest alles live uit de geopende tabel:
  a) tabel mét gewicht-kolom (kop bevat weight/poids, waardes als bereik
     "55.5-62.3"): klantgewicht in de band van een rij -> die maat.
     Eenheid (kg/lbs) autodetectie uit de kop; metrische waarde uit
     Kiwi's data-unit-values (key "1") wint als die er is.
  b) tabel zonder gewicht-kolom: generieke schatting per gender
     (gecorrigeerd gewicht = kg + (lengte - basislengte) * 0.4),
     daarna geklemd op de maten die déze tabel echt bevat.
  Sizing-up-bias in beide modi: grenswaarde -> groter; bovenste 15%
  van een band -> één maat groter; >=190 cm én bovenste helft -> idem
  (max één stap). Geen quiz bij nummermaten (schoenen) of als er geen
  gewicht-kolom én geen gender is.
*/
(function () {
  'use strict';

  if (!document.querySelector('[data-section-type="nomu-product"]')) return;

  var TXT = {
    title: 'PAS SÛR(E) ? TROUVEZ VOTRE TAILLE',
    height: 'Taille (cm)',
    weight: 'Poids (kg)',
    submit: 'TROUVER MA TAILLE',
    recommend: 'NOUS RECOMMANDONS LA TAILLE ',
    addToCart: 'AJOUTER AU PANIER',
    continueShopping: 'CONTINUER MES ACHATS',
    smallest: 'C’est notre plus petite taille.',
    largest: 'C’est notre plus grande taille.',
    soldOut: 'La taille {size} est actuellement épuisée.',
    closest: 'Taille disponible la plus proche pour ce produit.',
    needWeight: 'Renseignez votre poids (kg) pour obtenir un conseil.'
  };

  var ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];
  // generieke banden: bovengrens gecorrigeerd gewicht per maat
  var BANDS = {
    men: [54, 62, 73, 84, 95, 106],
    women: [46, 52, 60, 68, 76, 84]
  };
  var BASE_HEIGHT = { men: 178, women: 166 };

  function normSize(s) {
    s = String(s || '').trim().toUpperCase().replace(/\s+/g, '');
    if (s === 'XXL') return '2XL';
    if (s === 'XXXL') return '3XL';
    return s;
  }

  function productGender() {
    var root = document.querySelector('[data-section-type="nomu-product"]');
    var hay = (location.pathname + ' ' +
      (root.getAttribute('data-product-handle') || '') + ' ' +
      (root.getAttribute('data-product-title') || '')).toLowerCase();
    // femme/women vóór homme/men — 'women' bevat 'men'
    if (/femme|women/.test(hay)) return 'women';
    if (/homme|\bmen\b|men-|-men/.test(hay)) return 'men';
    return null;
  }

  /* ---- tabel-parsing ------------------------------------------------ */

  function metricCellText(cell) {
    // Kiwi unit-toggle: data-unit-values='{"0":"40.9","1":"104"}' — 1 = metrisch
    var uv = cell.getAttribute('data-unit-values');
    if (uv) {
      try {
        var o = JSON.parse(uv);
        if (o && o['1'] != null) return { text: String(o['1']), metric: true };
      } catch (e) { /* val terug op zichtbare tekst */ }
    }
    return { text: cell.textContent.trim(), metric: false };
  }

  function parseRange(text) {
    var m = String(text).replace(/,/g, '.').match(/(\d+(?:\.\d+)?)\s*[-–—]\s*(\d+(?:\.\d+)?)/);
    if (!m) return null;
    var lo = parseFloat(m[1]), hi = parseFloat(m[2]);
    if (isNaN(lo) || isNaN(hi) || hi <= lo) return null;
    return [lo, hi];
  }

  function parseTable(modal) {
    var table = modal.querySelector('.ks-table');
    if (!table) return null;
    var rows = Array.prototype.slice.call(table.querySelectorAll('tr'));
    if (rows.length < 2) return null;

    var headCells = Array.prototype.slice.call(rows[0].querySelectorAll('td, th'));
    var weightCol = -1;
    var weightUnit = 'kg';
    headCells.forEach(function (c, i) {
      if (i === 0 || weightCol > -1) return;
      var t = c.textContent;
      if (/weight|poids|gewicht/i.test(t)) {
        weightCol = i;
        if (/lb/i.test(t)) weightUnit = 'lb';
      }
    });

    var sizes = [];
    rows.slice(1).forEach(function (r) {
      var cells = r.querySelectorAll('td, th');
      if (!cells.length) return;
      var name = normSize(cells[0].textContent);
      if (!name) return;
      var entry = { name: name, range: null };
      if (weightCol > -1 && cells[weightCol]) {
        var val = metricCellText(cells[weightCol]);
        entry.range = parseRange(val.text);
        if (entry.range && val.metric) entry.metric = true;
      }
      sizes.push(entry);
    });
    if (!sizes.length) return null;

    return {
      sizes: sizes,
      numeric: sizes.every(function (s) { return /^\d+(\.\d+)?$/.test(s.name); }),
      hasWeights: weightCol > -1 && sizes.some(function (s) { return s.range; }),
      weightUnit: weightUnit
    };
  }

  /* ---- advies-logica ------------------------------------------------ */

  // max één stap groter: grens -> groter zit in de <-vergelijkingen zelf,
  // daarnaast: bovenste 15% van de band of (>=190cm en bovenste helft)
  function upBias(frac, heightCm) {
    if (frac >= 0.85) return true;
    if (heightCm >= 190 && frac >= 0.5) return true;
    return false;
  }

  function recommendFromWeights(parsed, kg, heightCm) {
    var rows = parsed.sizes.filter(function (s) { return s.range; });
    if (!rows.length) return null;
    // metrische data-unit-values zijn al kg; anders omrekenen bij lbs-kop
    var toRowUnit = function (row) {
      if (row.metric || parsed.weightUnit === 'kg') return kg;
      return kg * 2.20462;
    };
    var first = rows[0], last = rows[rows.length - 1];
    if (toRowUnit(first) < first.range[0]) return { size: first.name, note: 'smallest' };
    if (toRowUnit(last) >= last.range[1]) return { size: last.name, note: 'largest' };
    var idx = -1;
    for (var i = 0; i < rows.length; i++) {
      var w = toRowUnit(rows[i]);
      var r = rows[i].range;
      if (w >= r[0] && w < r[1]) { idx = i; break; }
      // gat tussen banden: sizing-up naar de eerstvolgende rij
      if (w < r[0]) { idx = i; break; }
    }
    if (idx === -1) idx = rows.length - 1;
    var rr = rows[idx].range;
    var frac = (toRowUnit(rows[idx]) - rr[0]) / (rr[1] - rr[0]);
    if (upBias(frac, heightCm) && idx < rows.length - 1) idx++;
    return { size: rows[idx].name, note: null };
  }

  function recommendGeneric(gender, kg, heightCm, parsed) {
    var adjusted = kg + (heightCm ? (heightCm - BASE_HEIGHT[gender]) * 0.4 : 0);
    var bounds = BANDS[gender];
    var idx = bounds.length; // 3XL
    for (var i = 0; i < bounds.length; i++) {
      if (adjusted < bounds[i]) { idx = i; break; }
    }
    if (idx < bounds.length) {
      var upper = bounds[idx];
      var lower = idx === 0 ? upper - (bounds[1] - bounds[0]) : bounds[idx - 1];
      if (upBias((adjusted - lower) / (upper - lower), heightCm)) {
        idx = Math.min(idx + 1, ORDER.length - 1);
      }
    }
    var estimate = ORDER[idx];

    // klemmen op de maten die déze tabel echt bevat
    var tableSizes = parsed.sizes.map(function (s) { return s.name; })
      .filter(function (n) { return ORDER.indexOf(n) > -1; });
    if (!tableSizes.length) return null;
    if (tableSizes.indexOf(estimate) > -1) return { size: estimate, note: null };

    var want = ORDER.indexOf(estimate);
    var best = null, bestDist = Infinity;
    tableSizes.forEach(function (n) {
      var d = Math.abs(ORDER.indexOf(n) - want);
      // gelijke afstand -> de grotere maat
      if (d < bestDist || (d === bestDist && ORDER.indexOf(n) > ORDER.indexOf(best))) {
        best = n; bestDist = d;
      }
    });
    var note = 'closest';
    if (ORDER.indexOf(best) === Math.min.apply(null, tableSizes.map(function (n) { return ORDER.indexOf(n); })) && want < ORDER.indexOf(best)) note = 'smallest';
    if (ORDER.indexOf(best) === Math.max.apply(null, tableSizes.map(function (n) { return ORDER.indexOf(n); })) && want > ORDER.indexOf(best)) note = 'largest';
    return { size: best, note: note };
  }

  /* ---- buy-box koppeling -------------------------------------------- */

  function findSizeInput(size) {
    var target = normSize(size);
    var inputs = document.querySelectorAll('.nomu-pdp__sizes input[type=radio]');
    for (var i = 0; i < inputs.length; i++) {
      if (normSize(inputs[i].value) === target) return inputs[i];
    }
    return null;
  }

  function selectSize(input) {
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function closeModal(modal) {
    var btn = modal.querySelector('.ks-modal-close') || document.querySelector('.ks-modal-close');
    if (btn) btn.click();
  }

  /* ---- UI ------------------------------------------------------------ */

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function buildQuiz(modal) {
    if (modal.querySelector('.val-squiz')) return;
    var wrapper = modal.querySelector('.ks-table-wrapper');
    if (!wrapper) return;

    var parsed = parseTable(modal);
    if (!parsed || parsed.numeric) return; // schoenen e.d.
    var gender = productGender();
    if (!parsed.hasWeights && !gender) return; // niets om op te adviseren

    var quiz = el('div', 'val-squiz');
    quiz.appendChild(el('p', 'val-squiz__title', TXT.title));

    var fields = el('div', 'val-squiz__fields');
    function field(labelText, inputId) {
      var f = el('div', 'val-squiz__field');
      var label = el('label', null, labelText);
      label.setAttribute('for', inputId);
      var input = el('input');
      input.type = 'number';
      input.id = inputId;
      input.min = '0';
      input.inputMode = 'decimal';
      f.appendChild(label);
      f.appendChild(input);
      fields.appendChild(f);
      return input;
    }
    var heightInput = field(TXT.height, 'val-squiz-height');
    var weightInput = field(TXT.weight, 'val-squiz-weight');
    quiz.appendChild(fields);

    var submit = el('button', 'val-squiz__submit', TXT.submit);
    submit.type = 'button';
    quiz.appendChild(submit);

    var result = el('div', 'val-squiz__result');
    result.hidden = true;
    quiz.appendChild(result);

    submit.addEventListener('click', function () {
      result.hidden = false;
      result.textContent = '';

      var kg = parseFloat(String(weightInput.value).replace(',', '.'));
      var cm = parseFloat(String(heightInput.value).replace(',', '.')) || 0;
      if (!kg || kg <= 0) {
        result.appendChild(el('p', 'val-squiz__note', TXT.needWeight));
        return;
      }

      // vers parsen: de tabel kan intussen van eenheid gewisseld zijn
      var fresh = parseTable(modal) || parsed;
      var rec = fresh.hasWeights
        ? recommendFromWeights(fresh, kg, cm)
        : (gender ? recommendGeneric(gender, kg, cm, fresh) : null);
      if (!rec) {
        result.appendChild(el('p', 'val-squiz__note', TXT.needWeight));
        return;
      }

      result.appendChild(el('p', 'val-squiz__size', TXT.recommend + rec.size));
      if (rec.note === 'smallest') result.appendChild(el('p', 'val-squiz__note', TXT.smallest));
      if (rec.note === 'largest') result.appendChild(el('p', 'val-squiz__note', TXT.largest));
      if (rec.note === 'closest') result.appendChild(el('p', 'val-squiz__note', TXT.closest));

      var input = findSizeInput(rec.size);
      var unavailable = input && input.closest('label') &&
        input.closest('label').classList.contains('is-unavailable');
      if (!input || unavailable) {
        if (unavailable) {
          result.appendChild(el('p', 'val-squiz__note', TXT.soldOut.replace('{size}', rec.size)));
        }
        return; // geen actieknoppen
      }

      var actions = el('div', 'val-squiz__actions');
      var atcBtn = el('button', 'val-squiz__atc', TXT.addToCart);
      atcBtn.type = 'button';
      atcBtn.addEventListener('click', function () {
        selectSize(input);
        closeModal(modal);
        var atc = document.querySelector('.nomu-pdp [data-atc]');
        if (atc && !atc.disabled) atc.click();
      });
      var contBtn = el('button', 'val-squiz__cont', TXT.continueShopping);
      contBtn.type = 'button';
      contBtn.addEventListener('click', function () {
        selectSize(input);
        closeModal(modal);
      });
      actions.appendChild(atcBtn);
      actions.appendChild(contBtn);
      result.appendChild(actions);
    });

    var footer = wrapper.parentElement.querySelector('.ks-table-footer');
    if (footer) {
      footer.parentElement.insertBefore(quiz, footer);
    } else {
      wrapper.insertAdjacentElement('afterend', quiz);
    }
  }

  function scan() {
    var modal = document.querySelector('.kiwi-sizing-modal-inner');
    if (modal && modal.querySelector('.ks-table')) buildQuiz(modal);
  }

  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  scan();
})();
